// Local translations
export const T = {
  en_GB: {
    activity: "Activity",
    flows: "Flows",
    accounts: "Accounts",
    notesAndFiles: "Notes & files",
    members: "Members",
    orders: "Orders",
    recurringOrders: "Recurring orders",
    mandateOrders: "Mandate orders",
    savingsPlans: "Savings plans",
    mandates: "Mandates",
    partiesPerson: "POA / Guardian",
    partiesCompany: "Representatives",
    partiesGroup: "Representatives",
  },
  nb_NO: {
    activity: "Aktivitet",
    flows: "Flyter",
    accounts: "Kontoer",
    notesAndFiles: "Notater og filer",
    members: "Medlemmer",
    orders: "Ordrer",
    recurringOrders: "Faste ordrer",
    mandateOrders: "Mandatordrer",
    savingsPlans: "Spareavtaler",
    mandates: "Mandater",
    partiesPerson: "Fullmakt / verge",
    partiesCompany: "Representanter",
    partiesGroup: "Representanter",
  },
} as const;
